<template>
  <div :class="'dynamic-field ' + ((hideMark || !ownerIsUser) ? 'hide-mark' : '')" :data-left="'-' + left + 'px'"
    :style="'background:white;position:absolute;min-width:' +
    width +
    'px;width:' +
    width +
    'px;height:' +
    height +
    'px;top:' +
    top +
    'px;left:' +
    left +
    'px;' +
    '--pos-left:-' +
    left +
    'px;' +
    'border-right:' +
    (!currentVal ? '6px solid ' + (color || '#7CB9E8') : '0') +
    ';' +
    'border-color:' +
    (color || '#7CB9E8') +
    ';' +
    (disabled || !!currentVal ? '' : 'box-shadow: -5px 10px 20px -10px rgba(68, 138, 255, 0.25);')
    ">
    <div :style="disabled && value ? 'opacity:0;' : ''">
      <date-picker v-if="type === 'date'" v-model="selectedDate" valueType="format" :disabled="disabled"
        :required="required" ref="datepicker" style="background: white" :format="dateFormat"
        :class="'dynamic-date-field dynamic-date-field-' + index" :placeholder="'Select date' + (required ? ' *' : '')">

      </date-picker>
      <!-- <md-datepicker
        v-model="selectedDate"
        v-if="type === 'date'"
        :disabled="disabled"
        :required="required"
        ref="datepicker"
        style="background: white"
        class="dynamic-date-field"
      >
        <label v-if="!selectedDate">{{'Select date'+(required?' *':'')}}</label>
      </md-datepicker> -->

      <SignField :disabled="disabled" v-if="type === 'sign' || type === 'signature'" :index="index" :value="value"
        :height="height" :width="width"  :top="top"  :left="left" :required="required" :signMethods="signMethods || []" @change="onChange" @rawValue="onChangeRawValue"/>

      <CustomTextField :disabled="disabled" v-if="type === 'text'" :index="index" :value="value" :height="height"
        :width="width" :required="required" :signMethods="signMethods || []" @change="onChange" @rawValue="onChangeRawValue" @fieldProps="onChangeFieldProps"/>

      <!-- <md-field
        style="padding-top: 0; min-height: 34px"
        v-if="type === 'text'"
        class="dynamic-text-field"
      >
      <label v-if="!text">Text</label>
      <md-input :disabled="disabled"  :required="required" v-model="text"></md-input>
      <md-icon v-if="!text">text_format</md-icon>
      </md-field> -->



      <div style="padding-top: 0; min-height: 34px" v-if="type === 'new'" class="dynamic-new-field">
        <input style="font-size: 1.2em;" type="text" :disabled="disabled" :required="required" placeholder="Type..."
          @keydown="onKeyupInput" @blur="onBlurInput">
        <!-- <label v-if="!text">AAA</label>
      <md-input :disabled="disabled"  :required="required" v-model="text"></md-input>
      <md-icon v-if="!text">text_format</md-icon> -->
      </div>

      <md-checkbox v-if="type === 'check'" :disabled="disabled" :required="required" v-model="checked"
        class="md-primary dynamic-check-field"><span></span></md-checkbox>
    </div>
    <md-tooltip md-direction="top">
      <div>
        <div style="text-align: center;"> {{ name ? name + " (" + owner + ")" : owner }}</div>
        <div style="text-align: center;" v-if="!!date"> {{ "[Signed date] " + date }}</div>
        <div style="text-align: center;" v-if="!!ip">{{ "[IP address] " + ip }}</div>
      </div>


    </md-tooltip>
    <!-- <md-tooltip md-direction="bottom" style="z-index: 5;transform: translateY(-40px);">{{'21.07.2021 11:00:55'}}</md-tooltip> -->
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Vue from "vue";
import SignField from "@/components/SignField.vue";
import CustomTextField from "@/components/CustomTextField.vue";
import domtoimage from "dom-to-image";
import axios from "axios";
export default {
  name: "DynamicField",
  components: {
    DatePicker,
    CustomTextField,
    SignField,
  },
  data() {
    return {
      dateFormat : 'DD.MM.YYYY',
      menuDate: false,
      currentVal: this.value,
      val: null,
      selectedDate: null,
      checked: false,
      text: "",
      colors: [
        "#7CB9E8",
        "#9966CC",
        "#E52B50",
        "#F19CBB",
        "#3B7A57",
        "#FFBF00",
        "#FF7E00",
        "#841B2D",
        "#008000",
        "#007FFF",
        "#87421F",
      ],
    };
  },

  props: {
    id: String,
    color: String,
    recipient: Object,
    type: String,
    index: Number,
    email: String,
    height: Number,
    width: Number,
    top: Number,
    left: Number,
    owner: String,
    ip: String,
    date: String,
    required: Boolean,
    hideMark: Boolean,
    disabled: Boolean,
    value: String,
    name: String,
    signMethods: Array,
  },
  watch: {
    selectedDate: function (newVal) {
      if (!newVal) {
        this.$emit("change", null);
        this.$emit("rawValue", null);
        this.currentVal = null;
      } else {
         this.$emit("rawValue", newVal);
        this.fieldToImage(".dynamic-date-field-" + this.index + " input");
      }
    },
    text: function (newVal) {
      if (!newVal) {
        this.$emit("change", null);
        this.$emit("rawValue", null);
        this.currentVal = null;
      } else {
 this.$emit("rawValue", newVal);
        this.fieldToImage(".dynamic-text-field input");
      }
    },
    checked: function (newVal) {
      let imgCheck = '';
      if (!newVal) {
        // this.val=null;
        // this.$emit("change", null);
        imgCheck = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA6CAYAAADspTpvAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAEASURBVGhD7duxiYVAFIXh4wgWYCTYgyWMfdiGIJi9zE4sxAIM7EEwMjETxOXK8NjNNvXM+aLxZn/gzW5ynueNYJomLMuCbdtwXVeYvlOapiiKAlVVwXsfpsATvO87xnHEuq5hzKUsSzRNgzzP4WzAHGuszRpNWtf1Z57n54PZcRzIsgzO/tlYWKuzBRULa03atv1u6d+GYQivd+r7Prz+epZWTBTMTsHsFMxOwewUzE7B7BTMTsHsFMxOwewUzE7B7BTMTsHsFMxOwewUzE7B7BTMTsHsFMxOwewUzC7puu5++wXLf9mli7NTl1hYq7O7nlhYq7MjJrvrYWeN3nv8ADg/Re9d7SQiAAAAAElFTkSuQmCC';
      } else {

        //  this.fieldToImage(".md-checkbox-container");
        imgCheck = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAITSURBVGhD7ds/S8NAGMfxJ1cHBaWDgjg6VLrrJoiCkyAIHX0D4isQXBwUxFegq3snwVVx1l3s4CgVHfwzSLGN/MqdSEls7pL0nrvkO+Vu+5DkKKFP0Ol0QpI17wTdPAh6fAnouys3HW2sQjQ/E9LKQo8aiz25S9QHP70FdHxZoVY7kNt+VZsNaW+jS3PVkAQ2fMYi2GBEAo+xz1gVjLAKvLNFCVaBA6oowSpcP411grU4z7OsBPteCfa9Eux7ToIPtoh21uRCM+fAwC7XiBpLZminwAqrMkE7Ax7EqnTRToDjsKrpSXmRIPbgYdjre6KjC7lIEGtw1ljEFpwHFrEE54VF7MB5YhErcN5YxAY8CixiAR4VFlkHjxKLjMHVCXmRolFjkRF4f5PosJEObQOLtMHArtaJ6nPmaFtYpAVWWJUJ2iYWJQYPYlU6aNtYlBj8+ikvIkqC5oBFicGnV0TNW7mI6D80FyzSeodN0JywSAuMdNDcsChYPwl//9SiE74j4XtSXB9fRFPjchGRDSzSvsOqYXeaIxYZg9EwdFQ2sSgVGOmgbWNRajACutWWi5ie3+1jUSZgtHsejwZ2+0wuLJcZGEWhOWFRpmD0F80NizIHI4XmhkXGPzxcLZc7zLkS7Hsl2PdKsO8JTH8UJVgFRl2KEqwCcz1FCVaBISbM9fgejLD2Dy0MMfmMVoNaqGCjeEQ//x70g/Cw8tAAAAAASUVORK5CYII=';
      }

      this.resizeImageToTransparentBase64(imgCheck, this.width, this.height)
        .then((resizedBase64) => {

          this.$emit("change", resizedBase64);
          this.$emit("rawValue", newVal);
          this.currentVal = resizedBase64;
        })
        .catch((error) => {
          console.error(error);
        });



    },
  },
  methods: {
    onBlurInput(e) {
      this.currentVal = e.target.value;
    },
    onKeyupInput(e) {
      // console.log(e)

      const newWidth = e.target.value.length * 5;
      e.target.parentElement.parentElement.parentElement.style.width = newWidth + 'px';
    },
    fieldToImage(elSelector) {
      var vm = this;
      setTimeout(function () {
        var node = vm.$el.querySelector(elSelector);

        domtoimage
          .toPng(node)
          .then(function (dataUrl) {


            var image = new Image();
            image.onload = function () {
              // create an off-screen canvas
              var canvas = document.createElement('canvas'),
                ctx = canvas.getContext('2d');

              // set its dimension to target size
              canvas.width = vm.width;
              canvas.height = vm.height;

              // draw source image into the off-screen canvas:
              ctx.drawImage(image, 0, 0);

              // encode image to data-uri with base64 version of compressed image
              dataUrl = canvas.toDataURL();
              vm.val = dataUrl;
              vm.$emit("change", vm.val);
              vm.currentVal = vm.val;
              console.log(dataUrl)
            };
            image.src = dataUrl;






          })
          .catch(function (error) {
            console.error(error);
          });
      }, 0);
    },
    scaleBase64Image(base64Image, newWidth, newHeight) {
      return new Promise((resolve, reject) => {
        const img = new Image();

        img.onload = () => {
          const aspectRatio = img.width / img.height;
          let scaledWidth, scaledHeight;

          if (newWidth / aspectRatio <= newHeight) {
            scaledWidth = newWidth;
            scaledHeight = newWidth / aspectRatio;
          } else {
            scaledWidth = newHeight * aspectRatio;
            scaledHeight = newHeight;
          }

          const canvas = document.createElement('canvas');
          canvas.width = scaledWidth;
          canvas.height = scaledHeight;
          const context = canvas.getContext('2d');
          context.drawImage(img, 0, 0, scaledWidth, scaledHeight);

          // Convert the canvas content to a base64 image
          const scaledBase64 = canvas.toDataURL('image/png');
          resolve(scaledBase64);
        };

        img.onerror = (err) => {
          reject(err);
        };

        img.src = base64Image;
      });
    },


    resizeImageToTransparentBase64(imageData, width, height) {
      return new Promise((resolve, reject) => {
        const img = new Image();

        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;

          const context = canvas.getContext('2d');
          context.clearRect(0, 0, canvas.width, canvas.height);
          context.fillStyle = 'transparent';
          context.fillRect(0, 0, canvas.width, canvas.height);
          context.drawImage(img, 0, 0, width, height);

          // Convert the canvas content to a base64 image
          const transparentBase64 = canvas.toDataURL('image/png');
          resolve(transparentBase64);
        };

        img.onerror = (err) => {
          reject(err);
        };

        img.src = imageData;
      });
    },
    onChange: function (val) {
      this.$emit("change", val);
      this.currentVal = val;
    },
    onChangeRawValue: function (val) {
      this.$emit("rawValue", val);
    },
    onChangeFieldProps: function (val) {
      this.$emit("fieldProps", val);
    },
  },
  mounted() {
    console.log('domtoimage', domtoimage);
    this.$material.locale.dateFormat = 'DD.MM.YYYY';
    if (this.disabled && this.type == "date") {
      this.$refs["datepicker"].$el.querySelector("input").disabled = true;
      this.$refs["datepicker"].$el.className += " disabled";
    }



      const vm=this;

if( localStorage.getItem("generalConfiguration")){
  vm.dateFormat= JSON.parse(localStorage.getItem("generalConfiguration"))["dateFormat"] || 'DD.MM.YYYY';
   
}else{
  axios({
              method: "get",
              url: "/config/config",
              baseURL: process.env.VUE_APP_BASE_API,
              headers: {
                Authorization:
                  "Bearer " + Vue.prototype.$userData.tokens.access.token,
              }
          }).then((responsConfig) => {
             
              var configObj = {};
              for (let index = 0; index < responsConfig.data.length; index++) {
                const element = responsConfig.data[index];
                if(element.key){
                  configObj[element.key]=element.value;
                  vm[element.key]=element.value;
                }
              }
              localStorage.setItem("generalConfiguration", JSON.stringify(configObj));
              vm.dateFormat= configObj.dateFormat || 'DD.MM.YYYY';
  
          });
}


  


  },
  computed: {

    ownerIsUser() {
      return Vue.prototype.$userData.user.email?.toLowerCase() == this.owner?.toLowerCase();
    },
    windowScrollY() {
      return window.scrollY;
    },
    assignColor() {
      return this.colors[0];
    },
  },
};
</script>

<style lang="scss">
textarea:focus,
input:focus {
  outline: none;
}

.dynamic-date-field.md-has-value .md-date-icon {
  display: none;
}

.dynamic-date-field label {
  left: 0 !important;
}

i.md-icon.md-icon-font.md-icon-image.md-date-icon.md-theme-default {
  position: absolute;
  right: 0;
}

.dynamic-field {
  background: transparent !important;
  width: 100%;

  div:not(.md-checkbox-container),
  span,
  input {
    background: transparent !important;
    width: 100%;
    padding-left: 0;
  }

  .md-field:after {
    display: none;
  }

  input {
    box-shadow: none !important;
    border-bottom: none !important;
    display: block !important;
    border: none !important;
  }
}

.dynamic-field .md-field>.md-icon:after {
  display: none !important;
}

.md-tooltip {
  height: auto !important;
}

.md-checkbox-label {
  padding-left: 5px !important;
}

.vdr .md-field label {
  top: 5px;
}

.md-datepicker.disabled svg {
  fill: #9e9e9e;
}

@media (min-width: 960px) {
  .md-tooltip {
    height: 32px;
    font-size: 14px;
    line-height: 32px;
  }
}

.hide-mark:before {
  display: none !important;
}

.dynamic-field .md-field {
  padding-top: 0 !important;
  min-height: unset !important;
}

.dynamic-field .md-field label {
  top: 6px !important;
}

.dynamic-field .md-checkbox {
  margin-top: 5% !important;
  margin-left: 10px !important;
}



.dynamic-field.foo:before {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateX(-32px) translateY(-50%) scale(1.5);
  z-index: 9;
  left: var(--pos-left);
  height: 20px;
  background-color: #f36806 !important;
  background: url(https://www.freeiconspng.com/uploads/arrow-icon--myiconfinder-23.png) no-repeat center center/cover;
  width: 20px;
  /* align-content: center; */
  text-align: center;
  border-radius: 10px;
  color: white;
  font-weight: bold;
}
</style>